import { USER_FORM_ERRORS_MESSAGES } from 'core/constants/users.constants';
import { EUserFormError, EUserFormType } from 'core/model/enums/users.enum';
import { IServiceErrorContent } from 'core/model/interfaces/service.interface';
import { IUserDetailRequest } from 'core/model/interfaces/users';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleSpecificErrors } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import { IUsersState } from '../types';

export const editUser = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/editUser`,
  async (data: IUserDetailRequest, { rejectWithValue }) => {
    try {
      await apiService.users.updateUser(data);
      notificationService.global.success('Los datos se han actualizado correctamente.');
    } catch (e) {
      const handledError = handleSpecificErrors(
        e,
        USER_FORM_ERRORS_MESSAGES[EUserFormType.EDIT],
        Object.values(EUserFormError),
      );
      if (handledError) return rejectWithValue(handledError);

      throw e;
    }
  },
);

export const editUserReducer: TSliceExtraReducer<IUsersState> = builder =>
  builder
    .addCase(editUser.pending, state => {
      state.form.loading = true;
      state.form.success = false;
      state.form.errors = {};
    })
    .addCase(editUser.rejected, (state, action) => {
      state.form.loading = false;
      state.form.success = false;
      const { code, message } = (action.payload ?? {}) as IServiceErrorContent;
      if (code === EUserFormError.PHONE) state.form.errors.phone = message;
    })
    .addCase(editUser.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
      state.form.errors = {};
    });
